<svg width="19" height="8" viewBox="0 0 19 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.6 3.2H2.2L4.6 0.8L3.8 0L0 3.8L3.8 7.5L4.6 6.7L2.4 4.4H18.6V3.2Z" fill="currentColor"/>
</svg>
